import React, { useContext } from "react";
import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  HStack,
  InputRightElement,
  Stack,
  Button,
  Heading,
  Text,
  useColorModeValue,
  Link,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import axios from "axios";
import { CORE_API_URL } from "../../../../config";
import { DeriveError } from "../../../utils/derive-error";
import { navigate } from "gatsby-link";
import { AppContext } from "../../../context/app-context";
import mixpanel from "mixpanel-browser";
export default function SignupCard() {
  const [showPassword, setShowPassword] = useState(false);
  const [user, setTempUser] = useState({});
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const context = useContext(AppContext);
  const { setUser } = context;

  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
    >
      <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6}>
        <Stack align={"center"}>
          <Heading fontSize={"4xl"} textAlign={"center"}>
            Sign up
          </Heading>
          <Text fontSize={"lg"} color={"gray.600"}>
            Remember to copy the template to where Botion is authorized in your
            workspace! ✌️
          </Text>
        </Stack>
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"lg"}
          p={8}
        >
          <Stack spacing={4}>
            <Box>
              <FormControl id="name" isRequired>
                <FormLabel>Name</FormLabel>
                <Input
                  onChange={(e) =>
                    setTempUser({ ...user, name: e.target.value })
                  }
                  type="text"
                />
              </FormControl>
            </Box>
            <FormControl id="email" isRequired>
              <FormLabel>Email address</FormLabel>
              <Input
                onChange={(e) =>
                  setTempUser({ ...user, email: e.target.value })
                }
                type="email"
              />
            </FormControl>
            <FormControl id="password" isRequired>
              <FormLabel>Password</FormLabel>
              <InputGroup>
                <Input
                  onChange={(e) =>
                    setTempUser({ ...user, password: e.target.value })
                  }
                  type={showPassword ? "text" : "password"}
                />
                <InputRightElement h={"full"}>
                  <Button
                    variant={"ghost"}
                    onClick={() =>
                      setShowPassword((showPassword) => !showPassword)
                    }
                  >
                    {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                  </Button>
                </InputRightElement>
              </InputGroup>
            </FormControl>
            <Stack spacing={10} pt={2}>
              <Button
                isLoading={loading}
                loadingText="Submitting"
                size="lg"
                className="bg-indigo-900 hover:bg-indigo-800 text-white"
                onClick={async () => {
                  mixpanel.track("Clicked sign up on sign up page");
                  try {
                    setLoading(true);
                    const response = await axios.post(
                      `${CORE_API_URL}/register`,
                      {
                        user,
                      },
                      {
                        headers: {
                          "Content-Type": "application/x-www-form-urlencoded",
                        },
                      }
                    );

                    const { data } = response;
                    localStorage.setItem("user", JSON.stringify(data.user));
                    setUser(data.user);
                    //navigate("/dashboard");
                    window.location.href = `${CORE_API_URL}/install?email=${user.email}`;
                  } catch (error) {
                    const err = DeriveError(error);
                    toast({
                      title: "Signup error.",
                      description: err,
                      status: "error",
                      duration: 9000,
                      isClosable: true,
                    });
                  } finally {
                    setLoading(false);
                  }
                }}
              >
                Sign up
              </Button>
            </Stack>
            <Stack pt={6}>
              <Text align={"center"}>
                Already a user? <Link color={"blue.400"}>Login</Link>
              </Text>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Flex>
  );
}
